export default {
  product: {
    id: 123,
    price: 123.33,
    name: "ZeusPay",
    video: require("@/assets/images/video_example.png"),
    picture: require("@/assets/images/product/product-placeholder.png"),
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam ornare, odio egestas elementum placerat, metus ligula faucibus nisl, in consectetur tellus erat sit amet neque. Aenean egestas nulla eu imperdiet eleifend. Curabitur commodo feugiat leo, ut sollicitudin nunc accumsan in. Sed laoreet tincidunt mattis.",
    features: [
      {
        id: 1,
        name: "Garantia de 7 dias",
        description: "Teste o produto nesse período",
        icon: "lock"
      },
      {
        id: 2,
        name: "Compra segura",
        description: "Ambiente 100% seguro e autenticado",
        icon: "shield"
      },
      {
        id: 3,
        name: "Entregue via e-mail",
        description: "Acesso em todos os dispositivos",
        icon: "smartphone-small"
      },
      {
        id: 4,
        name: "Suporte 24h",
        description: "Não fique com dúvidas",
        icon: "help"
      },
      {
        id: 5,
        name: "Pagamento com dois cartões",
        description: "Utiliza dois cartões diferentes",
        icon: "two-money-cards"
      }
    ]
  },
  similar: [
    {
      id: 1,
      name: "ZeusPay",
      description: "asfsfsdfsfdfsdfd",
      tag: "Desenvolvimento pessoal",
      picture: require("@/assets/images/product-page/product-image-yellow.png")
    },
    {
      id: 2,
      name: "ZeusPay",
      description: "asfsfsdfsfdfsdfd",
      tag: "Desenvolvimento pessoal",
      picture: require("@/assets/images/product-page/product-image-red.png")
    },
    {
      id: 3,
      name: "ZeusPay",
      description: "asfsfsdfsfdfsdfd",
      tag: "Desenvolvimento pessoal",
      picture: require("@/assets/images/product-page/product-image-purple.png")
    },
    {
      id: 4,
      name: "ZeusPay",
      description: "asfsfsdfsfdfsdfd",
      tag: "Desenvolvimento pessoal",
      picture: require("@/assets/images/product-page/product-image-yellow.png")
    },
    {
      id: 5,
      name: "ZeusPay",
      description: "asfsfsdfsfdfsdfd",
      tag: "Desenvolvimento pessoal",
      picture: require("@/assets/images/product-page/product-image-red.png")
    },
    {
      id: 6,
      name: "ZeusPay",
      description: "asfsfsdfsfdfsdfd",
      tag: "Desenvolvimento pessoal",
      picture: require("@/assets/images/product-page/product-image-purple.png")
    },
    {
      id: 7,
      name: "ZeusPay",
      description: "asfsfsdfsfdfsdfd",
      tag: "Desenvolvimento pessoal",
      picture: require("@/assets/images/product-page/product-image-purple.png")
    }
  ],
  reviews: []
};
